export const removeLocalStorageItems = (prefix: string): void => {
  for (const key of Object.keys(localStorage)) {
    if (key.startsWith(prefix)) {
      localStorage.removeItem(key);
    }
  }
};
